// extracted by mini-css-extract-plugin
export default {"Navstye":"Navgater_Navstye__Eybb0"};